import { message } from "antd";
import axios from "axios";
import * as COMMONS from "common/common";

const BASE_URL = `${import.meta.env.VITE_APP_API_URL}/api/m`;

export default class MasterApiBase {
	constructor() {
		this.axios = axios.create({
			withCredentials: true,
			baseURL: BASE_URL,
			timeout: 60000,
		});

		this.axios.interceptors.request.use(
			(config) => {
				return config;
			},
			(error) => {
				return error;
			},
		);

		this.axios.interceptors.response.use(
			(response) => {
				return Promise.resolve(response.data);
			},
			(error) => {
				switch (error?.response?.status) {
					case COMMONS.RESPONSE_SYSTEM_ERROR:
						message.error({
							content: COMMONS.ERROR_SYSTEM_MSG,
							key: COMMONS.MESSAGE_SYSTEM_ERROR_KEY,
						});
						break;

					case COMMONS.RESPONSE_BAD_REQUEST_ERROR:
						message.error({
							content: COMMONS.ERROR_400_MSG,
							key: COMMONS.MESSAGE_BAD_REQUEST_KEY,
						});
						break;

					case COMMONS.RESPONSE_CONFLICT_ERROR: {
						const errorMessage = error.response?.data?.message || error.response?.data;
						if (errorMessage === 'Another tab group is already scheduled during this time period') {
							message.error("この表示期間は他のリッチメニューと重複しています。既存のメニューを非公開にしてから再度お試しください。");
						} else if (typeof errorMessage === "string") {
							message.error(errorMessage);
						}
						break;
					}

					case COMMONS.RESPONSE_SESSION_ERROR:
						message.error({
							content: COMMONS.ERROR_SESSION_MSG,
							key: COMMONS.MESSAGE_SESSION_ERROR_KEY,
						});
						break;
					default:
						break;
				}

				return Promise.reject(error?.response?.data);
			},
		);

		this.endpoints = {
			members: "/members",
			richMenus: "/richmenus",
			customerRegistrations: "settings-customer-registrations",
			audiences: "/audiences",
			inflowSources: "/inflow-source",
		};
	}
}
